export const HST_MIDNIGHT = 'T00:00:00-10:00';

export enum Programs {
    HUBS = "HUBS",
    AP_PILLPACK = "AP_PILLPACK",
    AP_CONCESSIONS = "AP_CONCESSIONS"
}

export enum Frequencies {
    ONE_TIME = "ONE_TIME",
    FIXED_RECURRENCE = "FIXED_RECURRENCE"
}

// Concession reason values from FFR LLD ConcessionReason enum
// Ref: https://quip-amazon.com/ce1EA93QhxAC
export enum ConcessionsReasons {
    LOST_IN_TRANSIT = "LOST_IN_TRANSIT",
    DELIVERED_DAMAGED = "DELIVERED_DAMAGED",
    DELIVERED_NOT_RECEIVED = "DELIVERED_NOT_RECEIVED",
    DEFECTIVE_PRODUCT = "DEFECTIVE_PRODUCT",
    MISSING_CONTENT = "MISSING_CONTENT",
    TECHNICAL_MEDICATION_ERROR = "TECHNICAL_MEDICATION_ERROR",
    RETURNED_BY_CARRIER_RECALL = "RETURNED_BY_CARRIER_RECALL",
    LARGE_SCALE_EVENT = "LARGE_SCALE_EVENT"
}

// Concession type values from ApaqPortalJavaLambdaModel ConcessionsFeatures.concessionType
// Ref: ApaqPortalJavaLambdaModel/model/structures.smithy
export enum ConcessionTypes {
    FREE_REPLACEMENT = "FREE_REPLACEMENT",
    CHARGED_REPLACEMENT = "CHARGED_REPLACEMENT",
    FULL_REFUND = "FULL_REFUND"
}

// Concession category values from ApaqPortalJavaLambdaModel ConcessionsFeatures.concessionCategory
// Ref: ApaqPortalJavaLambdaModel/model/structures.smithy
export enum ConcessionCategories {
    REPLACEMENT = "REPLACEMENT",
    REFUND = "REFUND"
}
